import sequencesService from '@/services/sequencesService'

const state = {
  schedules: [],
  selectedSchedule: {},
  selectedSequence: {},
  selectedSequencePerson: {},
  sequencePeople: [],
  sequenceStep: {},
  sequences: [],
  sequencesRule: {},
  sequencesRules: [],
  sequenceSteps: [],
  sequenceTotalSteps: 0,
  totalSequencePeople: 0,
  totalSequences: 0,
  totalSequencesRules: 0,
  totalSequencesSchedules: 0
}

const mutations = {
  'SET_SELECTED_SEQUENCE' (state, sequence) {
    state.selectedSequence = sequence
  },
  'SET_SEQUENCE_PEOPLE' (state, sequencePeople) {
    state.sequencePeople = sequencePeople
  },
  'SET_SEQUENCE_PERSON' (state, selectedSequencePerson) {
    state.selectedSequencePerson = selectedSequencePerson
  },
  'SET_SEQUENCE_STEPS' (state, steps) {
    state.sequenceSteps = steps
  },
  'SET_SEQUENCE_TOTAL_STEPS' (state, totalSteps) {
    state.sequenceTotalSteps = totalSteps
  },
  'SET_SEQUENCE_STEP' (state, step) {
    state.sequenceStep = step
  },
  'SET_SEQUENCES' (state, sequences) {
    state.sequences = sequences
  },
  'SET_SEQUENCES_RULE' (state, sequencesRule) {
    state.sequencesRule = sequencesRule
  },
  'SET_SEQUENCES_RULES' (state, sequencesRules) {
    state.sequencesRules = sequencesRules
  },
  'SET_SEQUENCES_SCHEDULES' (state, schedules) {
    state.schedules = schedules
  },
  'SET_SEQUENCES_SELECTED_SCHEDULE' (state, schedule) {
    state.selectedSchedule = schedule
  },
  'SET_TOTAL_SEQUENCE_PEOPLE' (state, totalSequencePeople) {
    state.totalSequencePeople = totalSequencePeople
  },
  'SET_TOTAL_SEQUENCES' (state, totalSequences) {
    state.totalSequences = totalSequences
  },
  'SET_TOTAL_SEQUENCES_RULES' (state, totalSequencesRules) {
    state.totalSequencesRules = totalSequencesRules
  },
  'SET_TOTAL_SEQUENCES_SCHEDULES' (state, totalSequencesSchedules) {
    state.totalSequencesSchedules = totalSequencesSchedules
  }
}

const actions = {
  async addListToSequence (vuexContext, { appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.addListToSequence(vuexContext.getters.token, app, data)
  },
  async changeUserFromSequence (vuexContext, { appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.updateSequencePerson(vuexContext.getters.token, app, data)
  },
  async createSequence (vuexContext, { appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    return await sequencesService.createSequence(vuexContext.getters.token, app, data)
  },
  async createSequencePerson (vuexContext, { appId, sequenceId, stepId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.createSequencePerson(vuexContext.getters.token, app, sequenceId, stepId, data)
  },
  async createSequencesRule (vuexContext, { appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.createSequencesRule(vuexContext.getters.token, app, data)
  },
  async createSequencesSchedule (vuexContext, { appId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.createSequencesSchedule(vuexContext.getters.token, app, data)
  },
  async createSequenceStep (vuexContext, { appId, sequenceId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.createSequenceStep(vuexContext.getters.token, app, sequenceId, data)
  },
  async deleteSequence (vuexContext, { appId, sequenceId }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.deleteSequence(vuexContext.getters.token, app, sequenceId)
  },
  async deleteSequenceStep (vuexContext, { appId, sequenceId, stepId }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.deleteSequenceStep(vuexContext.getters.token, app, sequenceId, stepId)
  },
  async deleteUserFromSequence (vuexContext, { appId, sequenceId, userId }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.deleteUserFromSequence(vuexContext.getters.token, app, sequenceId, userId)
  },
  async getSequence (vuexContext, { appId, sequenceId }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequence(vuexContext.getters.token, app, sequenceId)
      vuexContext.commit('SET_SELECTED_SEQUENCE', response)
    } catch (e) {
      vuexContext.commit('SET_SELECTED_SEQUENCE', {})
    }
  },
  async getSequencePerson (vuexContext, { appId, sequenceId, userId }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequencePerson(vuexContext.getters.token, app, sequenceId, userId)
      vuexContext.commit('SET_SEQUENCE_PERSON', response)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCE_PERSON', {})
    }
  },
  async getSequencePeople (vuexContext, { appId, sequenceId, pagination }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequencePeople(vuexContext.getters.token, app, sequenceId, pagination)
      vuexContext.commit('SET_SEQUENCE_PEOPLE', response.rows)
      vuexContext.commit('SET_TOTAL_SEQUENCE_PEOPLE', response.count)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCE_PEOPLE', [])
      vuexContext.commit('SET_TOTAL_SEQUENCE_PEOPLE', 0)
    }
  },
  async getSequences (vuexContext, { appId, pagination }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequences(vuexContext.getters.token, app, pagination)
      vuexContext.commit('SET_SEQUENCES', response.rows)
      vuexContext.commit('SET_TOTAL_SEQUENCES', response.count)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCES', [])
      vuexContext.commit('SET_TOTAL_SEQUENCES', 0)
    }
  },
  async getSequencesRules (vuexContext, { appId }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequencesRules(vuexContext.getters.token, app)
      vuexContext.commit('SET_SEQUENCES_RULES', response.rows)
      vuexContext.commit('SET_TOTAL_SEQUENCES_RULES', response.count)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCES_RULES', [])
      vuexContext.commit('SET_TOTAL_SEQUENCES_RULES', 0)
    }
  },
  async getSequencesRule (vuexContext, { appId, ruleId }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequencesRule(vuexContext.getters.token, app, ruleId)
      vuexContext.commit('SET_SEQUENCES_RULE', response)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCES_RULE', {})
    }
  },
  async getSequencesSchedule (vuexContext, { appId, scheduleId }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequencesSchedule(vuexContext.getters.token, app, scheduleId)
      vuexContext.commit('SET_SEQUENCES_SELECTED_SCHEDULE', response)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCES_SELECTED_SCHEDULE', {})
    }
  },
  async getSequencesSchedules (vuexContext, { appId, pagination }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequencesSchedules(vuexContext.getters.token, app, pagination)
      vuexContext.commit('SET_SEQUENCES_SCHEDULES', response.rows)
      vuexContext.commit('SET_TOTAL_SEQUENCES_SCHEDULES', response.count)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCES_SCHEDULES', [])
      vuexContext.commit('SET_TOTAL_SEQUENCES_SCHEDULES', 0)
    }
  },
  async getSequenceStep (vuexContext, { appId, sequenceId, stepId }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequenceStep(
        vuexContext.getters.token,
        app,
        sequenceId,
        stepId
      )
      vuexContext.commit('SET_SEQUENCE_STEP', response)
    } catch (e) {
      vuexContext.commit('SET_SEQUENCE_STEP', {})
    }
  },
  async getSequenceSteps (vuexContext, { appId, sequenceId, setStepsLocally = false }) {
    const app = appId || vuexContext.getters.appUuid
    try {
      const response = await sequencesService.getSequenceSteps(
        vuexContext.getters.token,
        app,
        sequenceId
      )
      if (setStepsLocally) {
        return response.rows
      } else {
        vuexContext.commit('SET_SEQUENCE_STEPS', response.rows)
        vuexContext.commit('SET_SEQUENCE_TOTAL_STEPS', response.count)
      }
    } catch (e) {
      if (setStepsLocally) {
        return []
      } else {
        vuexContext.commit('SET_SEQUENCE_STEPS', [])
        vuexContext.commit('SET_SEQUENCE_TOTAL_STEPS', 0)
      }
    }
  },
  async runSequence (vuexContext, { appId, sequenceId }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.runSequence(vuexContext.getters.token, app, sequenceId)
  },
  async stopSequence (vuexContext, { appId, sequenceId }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.stopSequence(vuexContext.getters.token, app, sequenceId)
  },
  async updateSequence (vuexContext, { appId, sequenceId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.updateSequence(vuexContext.getters.token, app, sequenceId, data)
  },
  async updateSequencesRule (vuexContext, { appId, ruleId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.updateSequencesRule(vuexContext.getters.token, app, ruleId, data)
  },
  async updateSequencesSchedule (vuexContext, { appId, scheduleId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.updateSequencesSchedule(vuexContext.getters.token, app, scheduleId, data)
  },
  async updateSequenceStep (vuexContext, { appId, sequenceId, stepId, data }) {
    const app = appId || vuexContext.getters.appUuid
    await sequencesService.updateSequenceStep(vuexContext.getters.token, app, sequenceId, stepId, data)
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
